import { Directive, OnDestroy, OnInit } from '@angular/core';
import { LocalStorageService } from '@vendasta/uikit';
import { Observable, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AppConfigService } from '../../core/app-config.service';
import { Site, SiteService } from '../../core/site';
import { SiteEditService } from '../../core/site-edit';
import { SiteUpdate } from '../../core/site/site';
import { UserService } from '../../core/user.service';
import { SelectedSiteService } from '../../selected-site.service';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Directive()
export class BaseHomeComponent implements OnInit, OnDestroy {
  site$: Observable<Site>;
  editRedirectURL$: Observable<string>;
  siteUpdate$: Observable<SiteUpdate>;
  siteUpdateErr = false;
  protected subscriptions: Subscription[] = [];

  constructor(
    protected siteService: SiteService,
    protected selectedSiteService: SelectedSiteService,
    protected diviUrlsService: SiteEditService,
    protected localStorageService: LocalStorageService,
    protected appConfigService: AppConfigService,
    protected userService: UserService,
    public readonly analyticsService: ProductAnalyticsService,
  ) {
    this.site$ = this.siteService.get();
    this.editRedirectURL$ = this.diviUrlsService.getEditUrl();
  }

  ngOnInit(): void {
    this.siteUpdate$ = this.site$.pipe(switchMap((site: Site) => this.siteService.getSiteUpdate(site.domain)));
    this.siteUpdate$.subscribe({
      error: () => {
        this.siteUpdateErr = true;
      },
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  public isSafari(): boolean {
    return window.navigator.userAgent.indexOf('Safari') !== -1 && window.navigator.userAgent.indexOf('Chrome') === -1;
  }

  navigateToEditSite(siteId: string, editUrl: string): void {
    this.analyticsService.trackEvent('editmysite:editsite-request', 'editmysite', 'editmysite-request');
    window.open('/redirect/wp-admin/' + siteId + '/?redirect_to=' + encodeURIComponent(editUrl), '_blank');
  }
}
